export default __webpack_public_path__ + "static/gnh-meshery-2677cd1848e258fe8f4de954c31a1a9e.webp";